module.exports = __webpack_public_path__ + "img/ch14_09_镇口围观.9bd05150.jpg";